export class WhatsappUtil {
	openWhatsappForPackage = (name, price, url) => {
		const message = `Hi Trip Store Team,\nI would like to know more about this package:\n\nName: ${name}\nPrice: ${price}\nURL: ${url}`
		const waUrl = `https://wa.me/919209200041?text=${encodeURIComponent(message)}`
		window.open(waUrl, "_blank")
	}
}
